import { CourseTopicActions } from '../ActionTypes';

export const setAllCourseTopics = (courseTopics) => ({
    type: CourseTopicActions.SetAll,
    courseTopics
});
